import React from 'react';
import PropTypes from 'prop-types';
import { DeleteOutlined, FormOutlined, BellFilled } from '@ant-design/icons';
import { Row, Col, Popconfirm, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { onlyViewPropertyRole } from '~client/helpers/auth';

export default function NewContactItem(props) {
  const { t } = useTranslation();
  const { index, contact, handleEdit, handleDelete, onlyRead, contactApplyLevel, contactType } =
    props;

  return (
    <section className="landlord-contact__section" key={contact.id}>
      <div className="landlord-contact__header-container">
        <div className="landlord-contact__title-wrapper">
          <p className="landlord-contact__title">{`${t(
            `cms.landlord.contact.select.${contactType.toLowerCase()}.label`,
          )} ${index}`}</p>

          <If condition={contact.isBillingNotificationEmail}>
            <Tooltip title={t('cms.landlord.contact.billing_notification_email_notice')}>
              <BellFilled />
            </Tooltip>
          </If>
        </div>

        <If condition={!onlyRead && !onlyViewPropertyRole()}>
          <span className="landlord-contact__header-container__btn-container">
            <button className="landlord-contact__header-container__icon-wrap" onClick={handleEdit}>
              <FormOutlined style={{ fontSize: '16px', color: '#38b2a6' }} />
            </button>
            <span className="landlord-contact__header-container__line" />
            <Popconfirm
              overlayClassName="property-detail-wrapper__popconfirm"
              overlayStyle={{ maxWidth: 210 }}
              arrowPointAtCenter
              placement="topRight"
              title={t('cms.landlord.contact.double_confirm.title')}
              onConfirm={handleDelete}
              okText={t('cms.properties.edit.btn.yes')}
              okType="danger"
              cancelText={t('cms.properties.edit.btn.no')}
            >
              <button className="landlord-contact__header-container__icon-wrap" onClick={() => {}}>
                <DeleteOutlined style={{ fontSize: '16px', color: '#38b2a6' }} />
              </button>
            </Popconfirm>
          </span>
        </If>
      </div>
      <div className="landlord-contact__section-content">
        <Row gutter={16}>
          <Col span={12} className="landlord-contact__section-content__label">
            <label>{t('cms.landlord.contact.contact_name.label')}: </label>
            {contact.contactName || '-'}
          </Col>
          <Col span={12} className="landlord-contact__section-content__label">
            <label>{t('cms.landlord.contact.contact_email.label')}: </label>
            {contact.contactEmail || '-'}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12} className="landlord-contact__section-content__label">
            <label>{t('cms.landlord.contact.contact_phone.label')}: </label>
            {contact.contactPhone || '-'}
          </Col>
          <Col span={12} className="landlord-contact__section-content__label">
            <label>{t('cms.landlord.contact.contact_occupation.label')}: </label>
            {contact.occupation || '-'}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12} className="landlord-contact__section-content__label">
            <label>{t('cms.landlord.contact.contact_level.label')}: </label>
            {t(`cms.landlord.contact.contact_level.${contactApplyLevel.toLowerCase()}.label`)}
          </Col>
        </Row>
      </div>
    </section>
  );
}

NewContactItem.propTypes = {
  index: PropTypes.number.isRequired,
  contact: PropTypes.object,
  handleEdit: PropTypes.func,
  handleDelete: PropTypes.func,
  onlyRead: PropTypes.bool,
  contactApplyLevel: PropTypes.oneOf(['LANDLORD', 'BOOKING_TEAM', 'PROPERTY']),
  contactType: PropTypes.oneOf(['LANDLORD', 'BOOKING_TEAM', 'PROPERTY']),
};

NewContactItem.defaultProps = {
  index: 1,
  contact: {},
  handleEdit: () => {},
  handleDelete: () => {},
  accountOwners: [],
  getAccountOwners: () => {},
  currentRoleSlug: '',
  onlyRead: true,
  getLatestReferenceAndContact: () => {},
  contactApplyLevel: 'LANDLORD',
  contactType: 'LANDLORD',
};
